module.exports = __webpack_public_path__ + "static/img/home-page-delete.df5ff9ca.svg";